import { differenceInSeconds } from 'date-fns'
import { useEffect, useState } from 'react'

const getFormattedTime = (endDate: string, callback?: () => void) => {
    const secondsLeft = differenceInSeconds(new Date(endDate), new Date()) || 0
    const minutesLeft = Math.floor(secondsLeft / 60)
    const daysLeft = Math.floor(minutesLeft / 60 / 24)
    const hoursLeft = Math.floor((minutesLeft / 60) % 24)

    const secondsLeftFriendly = `${secondsLeft > 0 ? `${secondsLeft}s` : ''}`
    const minutesLeftFriendly = `${minutesLeft > 0 ? `${minutesLeft % 60}m` : ''}`
    const hoursLeftFriendly = `${hoursLeft > 0 ? `${hoursLeft}h` : ''}`
    const daysLeftFriendly = `${daysLeft > 0 ? `${daysLeft}d` : ''}`

    if (secondsLeft <= 0) {
        callback?.()
    }

    return (
        `${daysLeftFriendly} ${hoursLeftFriendly} ${hoursLeft < 1 && daysLeft < 1 ? minutesLeftFriendly : ``}`.trim() ||
        secondsLeftFriendly
    )
}

export const useCountdown = (endDate, callback) => {
    const [timeLeft, setTimeLeft] = useState(endDate ? getFormattedTime(endDate, undefined) : null)

    useEffect(() => {
        let interval

        if (timeLeft && endDate) {
            interval = setInterval(() => {
                setTimeLeft(
                    getFormattedTime(endDate, () => {
                        clearInterval(interval)
                        callback?.()
                    }),
                )
            }, 1000)
        }
        if (!timeLeft && endDate) {
            setTimeLeft(getFormattedTime(endDate, undefined))
        }

        return () => clearInterval(interval)
    }, [endDate, timeLeft])

    return timeLeft
}
